import { BaseEvent } from '@packages/shared/core/analytics/events/BaseEvent';
import { BaseEventHandler } from '@packages/shared/core/analytics/events/BaseEventHandler';

export class SRCheatingMainPageExpertsOpenedEvent extends BaseEvent {}

export class SRCheatingMainPageExpertsOpenedEventHandler extends BaseEventHandler {
  shouldTrack(event: BaseEvent): boolean {
    return event instanceof SRCheatingMainPageExpertsOpenedEvent;
  }

  async track() {
    return this.amplitudeService.logEvent('registration_experts_start_screen_open');
  }
}
